module.exports = __webpack_public_path__ + "static/media/meteor-rain.e0f68f9f.gif";